import StaticNonStaticMapBaseLoadable from './StaticNonStaticMapBaseLoadable.js';


const NonStaticMap = ({ children, lat, lng, noPopup, noDefaultMarker, zoom = 13, label, style, geoJSON, additionalCustomGeoJSON, inhibitAttribForTinySize }) => {
    return <StaticNonStaticMapBaseLoadable
        lat={lat}
        lng={lng}
        noPopup={noPopup}
        noDefaultMarker={noDefaultMarker}
        zoom={zoom}
        label={label}
        style={style}
        geoJSON={geoJSON}
        additionalCustomGeoJSON={additionalCustomGeoJSON}
        zoomControl={true} 
		scrollWheelZoom={true} 
		dragging={true} 
		touchZoom={true}
        inhibitAttribForTinySize={inhibitAttribForTinySize}
    >{children}</StaticNonStaticMapBaseLoadable>
};

export default NonStaticMap;
